import React, { useState } from "react";
import { Splitter, SplitterPanel } from "primereact/splitter";
import FromMailConfiguration from "../AdminScreenDetail/FromMailConfiguration.jsx";
import UserToAccountGroup from "../AdminScreenDetail/UserToAccountGroup.jsx";
import ToMailConfiguration from "../AdminScreenDetail/ToMailConfiguration.jsx";
export default function ConfigurationSpliter() {
  const [fromMailData, setFromMailData] = useState(null);
  const [toMailData, setToMailData] = useState(null);
  const [toMailDataRemove, setToMailDataRemove] = useState(false);
  const [refreshConfirmation, setRefreshConfirmation] = useState(null);

  function OnClickFromMailData(data) {
    setToMailDataRemove(true);
    setFromMailData(data);
  }
  function OnClickToMailData(data, confirmation) {
    setRefreshConfirmation(confirmation);
    setToMailDataRemove(false);
    setToMailData(data);
  }

  return (
    <div>
      <Splitter>
        <SplitterPanel
          size={25}
          minSize={25}
          className="flex align-items-center justify-content-center"
        >
          <UserToAccountGroup
            onClickFromMail={OnClickFromMailData}
            hideMultiSelect={"True"}
            setToMailData={setToMailData}
          />
        </SplitterPanel>
        <SplitterPanel
          size={25}
          minSize={25}
          className="flex align-items-center justify-content-center"
        >
          <FromMailConfiguration
            onClickToMail={OnClickToMailData}
            accountGroupCodeValue={fromMailData?.AccountGroupCode}
            accountGroupName={fromMailData?.AccountGroupName}
          />
        </SplitterPanel>
        <SplitterPanel
          size={50}
          minSize={50}
          className="flex align-items-center justify-content-center"
        >
          <ToMailConfiguration
            toMailDataRemove={toMailDataRemove}
            toMailAccountGroupCode={toMailData?.AccountGroupCode}
            toMailSenderId={toMailData?.SenderId}
            refreshConfirmation={refreshConfirmation}
          />
        </SplitterPanel>
      </Splitter>
    </div>
  );
}
